import ExamModeModel from '@/dex-shared/models/ExamModeModel';

export default {
  examModeById: (state: any, getters: any) => (examModeId: number) => {
    const examMode = state.exam_modes[examModeId];
    if (examMode) {
      return new ExamModeModel(examMode, getters);
    } else {
      return {};
    }
  },
  allExamModes: (state: any, getters: any) => {
    return Object.values(state.exam_modes).map(
      examMode => new ExamModeModel(examMode, getters),
    );
  },
};
